import React, { useState } from "react";
import { User } from "~/common/Store/models/User";
import CustomizationControls from "./CustomizationControls";
import NavigationMenu from "./NavigationMenu";

interface Props {
  user: User;
  loadingCart: boolean;
  openModal: () => void;
  isTrs: boolean;
}

const MainWindow = ({ user, loadingCart, openModal, isTrs }: Props) => {
  const [navigationSidebarVisible, setNavigationSidebarVisible] =
    useState(false);

  return (
    <div id="main-window" className="box customize__box customize__split">
      <NavigationMenu
        loadingCart={loadingCart}
        navigationSidebarVisible={navigationSidebarVisible}
        toggleNavigationSidebar={() =>
          setNavigationSidebarVisible(!navigationSidebarVisible)
        }
      />
      <CustomizationControls
        openModal={openModal}
        user={user}
        isTrs={isTrs}
        toggleNavigationSidebar={() =>
          setNavigationSidebarVisible(!navigationSidebarVisible)
        }
      />
    </div>
  );
};

export default MainWindow;
